export var resolveSupportPageUrl = function (entity) {
    if (!entity || !!entity.supportPageUrl) {
        return;
    }
    var path = "" + location.pathname;
    var supportPageUrl = path.match('\/supportpages\/[^\/]*');
    if (!supportPageUrl) {
        return;
    }
    entity.supportPageUrl = supportPageUrl.toString();
};
